export const portfolioHoldingConstants = {

    PORTFOLIO_HOLDING_SAGA: "PORTFOLIO_HOLDING_SAGA",
    PORTFOLIO_HOLDING_REQUEST: "PORTFOLIO_HOLDING_REQUEST",
    PORTFOLIO_HOLDING_RESPONSE: "PORTFOLIO_HOLDING_RESPONSE",
    PORTFOLIO_HOLDING_API: "v1/masters/portfolio-allocation",
};
